// extracted by mini-css-extract-plugin
module.exports = {"chart":"index_chart_2_fvB"};